import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { ButtonLoader } from '../../../shared_elements/components';
import {  globalPostService } from '../../../utils/globalApiServices';
import { checkApiStatus, getGlobalCookie, setGlobalCookie } from '../../../utils';
import appConfig from '../../../config';
import { useDispatch, useSelector } from 'react-redux';
import {  getUserLessorListApi } from '../../../shared_elements/actionCreators';
import { PageLoader } from '../../../shared_elements';
import { enqueueSnackbar } from 'notistack';
import { trackActivity } from '../../../utils/mixpanel';

const SwitchAccountModal = ({ onToggleModal }) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [isDropDownloading, setIsDropDownLoading] = useState({userLessorList:false});
  const { userLessorList } = useSelector((state) => state.leases)
  const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'))
  const [selectedLessor, setSelectedLessor] = useState(null);
  const oldValue = useRef(null);
  const env = appConfig?.env?.key;

  useEffect(() => {
    if(!userLessorList?.length){
      setIsDropDownLoading({userLessorList:true})
      dispatch(getUserLessorListApi({setIsDropDownLoading}))
    }
    trackActivity('Page Viewed', { page_title: 'Switch Account' });
  }, [])

  useEffect(() => {
    if(userLessorList?.length && !selectedLessor){
      setSelectedLessor(userLessorList?.find(item => item?.id === lessorAccess?.id) || null)
    }
  }, [userLessorList])

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: 'Switch Account', page_type: page_type });
  };

  const getUserInfo = (lessorId) => {
    if (lessorId === lessorAccess?.id) {
      enqueueSnackbar('Please Select Different Lessor', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
      return;
    }
    const payload = {
      lessor_id: lessorId,
      lite: true,
    }
    setLoading(true);
    globalPostService(`lessor-switch/`, payload).then(response => {
      if (checkApiStatus(response)) {
        setCookies(response?.data?.data)
        trackActivity('Account Switched', { page_title: 'Switch Account', success_msg: response?.data?.message, payload: payload, response: response?.data });
        onToggleModal();
        setLoading(false);
      } else {
        trackActivity('Account Switched', { page_title: 'Switch Account', error_msg: response?.data?.message, payload: payload, response: response?.data });
      }
      setLoading(false);
    })
  }
  const setCookies = (userData) => {
    const cookieData = JSON.stringify({ access: userData?.lessor_access_token, id: userData?.current_lessor?.id, refresh: "", environment: env, user: { id: userData?.user?.id, name: userData?.user?.name } })
    setGlobalCookie('lessorAccess', cookieData, 3);
    window.location.href = '/leases';
  }
  return (
    <>
      <Dialog
        disableEscapeKeyDown
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth={false}
        slotProps={{ paper: { sx: { width: '100%', maxWidth: '450px', m: 'auto', borderRadius: 2 } } }}
        open={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography className="delivery-header">Choose an account</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} m={1}>
            <Grid size={{ md: 12, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={userLessorList || []}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownloading?.userLessorList ? "loading" : "No Option Available"}
                value={selectedLessor}
                onOpen={() => {
                  oldValue.current = selectedLessor;
                  setSelectedLessor(null);
                }}
                onClose={(e, reason) => {
                  if (reason !== 'selectOption') {
                    setSelectedLessor(oldValue.current);
                  }
                }}
                onChange={(e, value) => { setSelectedLessor(value) }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Lessor Account to access"
                    margin='normal'
                    size='small'
                    required
                    placeholder={oldValue?.current?.name}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownloading?.userLessorList ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{marginRight: "15px"}}>
          <Button className='cancel-btn' disabled={false} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button'); }}> Cancel</Button>
          <Button variant="contained" size="small" className="btn-primary" onClick={() => { getUserInfo(selectedLessor?.id); handleItemClicked('Continue Button'); }}  > {isLoading ? <ButtonLoader /> : "continue"}</Button>
        </DialogActions>
        {isLoading ? <PageLoader /> : null}
      </Dialog>
    </>
  )
}

export default SwitchAccountModal